module.exports = __webpack_public_path__ + "static/media/server_room.bfae2d48.png";